import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/throw';

import { PassengerResponse } from './profile/passenger.model';
import { ActionUpdaterService } from './../shared/services/action-updater.service';

import * as error from '../shared/components/error-summary/error-handler.function';

declare function require(name: string): any;

@Injectable()
export class MyGreyhoundService {
    private DASHBOARD_STATE = 'dashboard_state';

    private getPassengerDetailsUrlFragment = '/umbraco/api/Passenger/GetPassengerDetails/';
    private getProgramsUrlFragment = '/umbraco/api/MyGreyhound/getPrograms/';
    private updateProgramUrl = '/umbraco/api/MyGreyhound/UpdateProgram';
    private updateCustomerDetailsUrl = '/umbraco/api/MyGreyhound/UpdateCustomerDetails';
    private deleteAccountUrl = '/umbraco/api/MyGreyhound/DeleteAccount';
    private getSubscriptionsUrl = '/umbraco/api/MyGreyhound/getSubscriptions';
    private updateSubscriptionUrl = '/umbraco/api/MyGreyhound/updateSubscriptions';
    private registrationNewsletterUrl = '/umbraco/api/AccountBaseUmbraco/HandleRegistrationNewsletter';
    private activateCustomerUsingResetKeyUrl = '/umbraco/api/AccountBaseUmbraco/ActivateCustomerUsingResetKey';
    private updateCustomerPasswordUrl = '/umbraco/api/AccountBaseUmbraco/UpdateCustomerPassword';
    private getLoyaltyBalanceUrl = '/umbraco/api/MyGreyhound/GetLoyaltyBalance';
    private getCustomerTransactionsUrl = '/umbraco/api/MyGreyhound/GetCustomerTransactions';
    private updateCustomerTCUrl = '/umbraco/api/MyGreyhound/UpdateCustomerTC';

    private repository: any;
    private dashboardState: DashboardState;

    // TODO This should be a store call using say ngStore can do this as I know the page will be reloaded on each navigation
    public currentPassenger = null;

    constructor(private http: Http, private actionUpdaterService: ActionUpdaterService) {
        const storageAvailable = require('storage-available');
        const isStorageAvailable = storageAvailable('localStorage');

        if (isStorageAvailable) {
            this.repository = window.localStorage;
        }

        this.dashboardState = this.getDashboardState();
    }

    getPassengerDetails(customerGuid: string): Observable<PassengerResponse> {
        const url = this.getPassengerDetailsUrlFragment + customerGuid;
        if (this.currentPassenger == null) {
            return this.http.get(url)
                .map(this.extractPassengerJson)
                .catch(error.handleError);
        } else {
            return this.currentPassenger;
        }
    }

    getPrograms(customerGuid: string): Observable<Array<LoyaltyProgram>> {
        return this.http.get(this.getProgramsUrlFragment + customerGuid)
            .map(this.extractJson)
            .catch(error.handleError);
    }

    getLoyaltyBalance(customerGuid: string): Observable<any> {
        return this.http.get(this.getLoyaltyBalanceUrl + '?CustomerGUID=' + customerGuid)
            .map(this.extractJson)
            .catch(error.handleError);
    }

    getCustomerTransactions(customerGuid: string): Observable<any> {
        return this.http.get(this.getCustomerTransactionsUrl + '?CustomerGUID=' + customerGuid)
            .map(this.extractJson)
            .catch(error.handleError);
    }

    registrationNewsletter(model: RegistrationNewsletter): Observable<any> {
        return this.http.post(this.registrationNewsletterUrl, model)
            .map(this.extractJson)
            .catch(error.handleError);
    }
    activateCustomerUsingResetKey(model: ActivateCustomerUsingResetKey): Observable<any> {
        return this.http.post(this.activateCustomerUsingResetKeyUrl, model)
            .map(this.extractJson)
            .catch(error.handleError);
    }
    updateCustomerPassword(model: UpdateCustomerPassword): Observable<any> {
        return this.http.post(this.updateCustomerPasswordUrl, model)
            .map(this.extractJson)
            .catch(error.handleError);
    }

    updateProgram(customerGuid: string, programId: string): Observable<Response> {
        const body = {
            CustomerGuid: customerGuid,
            ProgramId: programId
        };
        return this.http.post(this.updateProgramUrl, body)
            .map(this.extractJson)
            .catch(error.handleError);
    }

    updateCustomerDetails(options: UpdateCustomerDetailsOptions): Observable<Response> {
        return this.http.put(this.updateCustomerDetailsUrl, options)
            .map(this.extractJson)
            .catch(error.handleError);
    }

    deleteAccount(customerGuid: string): Observable<Response> {
        const url = this.deleteAccountUrl + '?CustomerGUID=' + customerGuid;
        return this.http.delete(url, customerGuid)
            .map(this.extractJson)
            .catch(error.handleError);
    }

    getSubscriptions(customerGuid: string) {
        const getSubscriptionsUrl = this.getSubscriptionsUrl + '?CustomerGUID=' + customerGuid;
        return this.http.get(getSubscriptionsUrl)
            .map(this.extractJson)
            .catch(error.handleError);
    }

    updateSubscriptions(options: SubscriptionOption, customerGuid: string): Observable<Response> {
        return this.http.put(this.updateSubscriptionUrl + '?CustomerGUID=' + customerGuid, options)
            .map(this.extractJson)
            .catch(error.handleError);
    }

    addBooking(options: AddBookingOptions) {
        const url = `/umbraco/api/MyGreyhound/AddBookingToCustomerV3/${options.customerGuid}`;
        return this.http.post(url, options)
            .map(this.extractJson)
            .catch(error.handleError);
    }

    addBookingV3(options: AddBookingOptionsV3) {
        const url = `/umbraco/api/MyGreyhound/AddBookingToCustomerV3/${options.customerGuid}`;
        return this.http.post(url, options)
            .map(this.extractJson)
            .catch(error.handleError);
    }

    updateCustomerTC(customerGuid: string) {
        return this.http.post(this.updateCustomerTCUrl + '?CustomerGUID=' + customerGuid, null)
                        .map(this.extractJson)
                        .catch(error.handleError);
    }

    getLoyaltyTrips(customerGuid: string) {
        const url = `/umbraco/api/MyGreyhound/GetLoyaltyTrips/${customerGuid}`;
        return this.http.get(url)
            .map(this.extractJson)
            .catch(error.handleError);
    }

    getTripHistory(customerGuid: string) {
        const url = `/umbraco/api/MyGreyhound/GetTripHistory/${customerGuid}`;
        return this.http.get(url)
            .map(this.extractJson)
            .catch(error.handleError);
    }

    getBookingSummary3(customerGuid: string) {
        const url = `/umbraco/api/MyGreyhound/GetBookingSummary/${customerGuid}?type=3`;
        return this.http.get(url)
            .map(this.extractJson)
            .catch(error.handleError);
    }

    getBookingSummary5(customerGuid: string) {
        const url = `/umbraco/api/MyGreyhound/GetBookingSummary/${customerGuid}?type=5`;
        return this.http.get(url)
            .map(this.extractJson)
            .catch(error.handleError);
    }

    forgotPassword(forgotPasswordEmail: ForgotPassword) {
        const url = `/umbraco/api/AccountBaseUmbraco/HandleForgotPassword`;
        return this.http.post(url, forgotPasswordEmail)
            .map(this.extractJson)
            .catch(error.handleError);
    }

    logoutUser = (returnUrl: string) => {
        const url = `/my-greyhound/login?logout=true`;
        return this.http.get(url)
            .catch(error.handleError);
    }

    private getDashboardState = (): DashboardState => {
        const dashboardState = this.repository.getItem(this.DASHBOARD_STATE);

        return dashboardState ? Object.assign(new DashboardState(), JSON.parse(dashboardState)) : new DashboardState();
    }

    public isDashboardItemSelected(key: string, defaultValue?: boolean) {
        const val = this.dashboardState.isSelected(key);
        if (val === undefined || val === null) {
            return defaultValue;
        } else {
            return val;
        }
    }

    public setDashboardItem(key: string, value: boolean) {
        this.dashboardState.setItem(key, value);
        this.repository.setItem(this.DASHBOARD_STATE, JSON.stringify(this.dashboardState));
    }

    private extractPassengerJson(res: Response) {
        const passenger = res.json();
        this.currentPassenger = passenger;
        return passenger;
    }

    private extractJson(res: Response) {
        const body = res.json();
        return body;
    }
}

export class AddBookingOptions {
    constructor(public customerGuid: string, private bookingNumber: string, private bookingPin: string, private companyId: string) { }
}

export class AddBookingOptionsV3 {
    constructor(public customerGuid: string, private bookingNumber: string, private companyId: string) { }
}

export class LoyaltyTripsResponse {
    LoyaltyTrips: Array<LoyaltyTrip>;
    ProgramDescription: string;
    TripsRemaining: number;
    TripCredits: number;
    TripsPending: number;
    LoyaltyCode: number;
}

export class LoyaltyTrip {
    IsCredit: boolean;
    IsPending: boolean;
    Description: string;
}

export class SubscriptionOption {
    constructor(private Subscriptions: Array<SubscriptionOptionItem>) { }
}

export class SubscriptionOptionItem {
    SourceId: string;
    Reason: string;
    constructor(private NewsletterID: string, private IsSubscribed: boolean, private Page: string, private IsMyGreyhound:boolean) {
        switch(Page) {
            case "activation":
                this.SourceId = '4';
                break;
            case "manage":
                if(IsMyGreyhound) {
                    this.SourceId = '8';
                }
                else {
                    this.SourceId = '14';
                }
                break;
            case "profile":
                this.SourceId = '7';
                break;
            default:
                this.SourceId = '9';
                break;
        }
     }
}

export class LoyaltyProgram {
    Description: string;
    ID: number;
    StartDate: Date;
    EndDate: Date;
    SelectedProgram: boolean;
}

export class UpdateCustomerDetailsOptions {
    CustomerGUID: string;
    Title: string;
    FirstName: string;
    Surname: string;
    Email: string;
    Phone: string;
    CountryCode: string;
    Country: string;
    Address: string;
    City: string;
    State: string;
    Postcode: string;
    Dob: Date;
    Source: string;
}

export class TripHistoryResponse {
    Description: string;
    Bookings: Array<CustomerTrip>;
}

export class CustomerTrip {
    Description: string;
    BookingNumber: string;
    BookingGuid: string;
    Loyalty: CustomerTripLoyalty;
    ProductType: string;
    PassExpiry: string;
}

export class CustomerTripLoyalty {
    LoyaltyStatus: string;
    TravelDate: string;
}

class DashboardState {
    items: { [key: string]: boolean };

    constructor() {
        this.items = {};
    }

    isSelected(key: string) {
        return this.items[key];
    }

    setItem(key: string, value: boolean) {
        this.items[key] = value;
    }
}

export class RegistrationNewsletter {
    constructor(public FirstName: string, public Surname: string, public Email: string) {

    }
}
export class ForgotPassword {
    constructor(public ForgotPasswordEmail: string, public Token: string, public SendEmail: boolean = true) {

    }
}

export class ActivateCustomerUsingResetKey {
    constructor(public ActivationKey: string, public RequireConfirmationEmail: boolean, public CustomerGuid: string, public ActivationStatus: boolean) {

    }
}

export class UpdateCustomerPassword {
    constructor(public customerReference?: string, public newPassword?: boolean, public currentPassword?: string, public UpdateType?: string) {

    }
}




// WEBPACK FOOTER //
// ./src/app/my-greyhound/my-greyhound.service.ts